const Container = (Component) => Component;

export default Container;
